import moment from 'moment'
import dayjs from 'dayjs'
export const get_all_months = (locale = 'ja-JP'): Array<any> => {
  moment.locale(locale)
  return moment.monthsShort() || []
}
// Convert a string time to display in correct format: Example "10:09:03.345678" to "10:09:03"
export const timeToString = (timeStr: string, format = 'HH:mm:ss'): string => {
  if (!timeStr) return ''
  const parsedTime = dayjs(`2024-01-01 ${timeStr}`, {format: 'YYYY-MM-DD HH:mm:ss.SSSSSS'}) // parse a valid date with time string to dayjs object
  return parsedTime.format('HH:mm:ss')
}

export const formatDateWithWeek = (dateStr: string): string => {
  moment.locale('ja-JP')
  if (!dateStr) return ''
  const dateMoment = moment(dateStr)
  return `${dateMoment.format("YY/MM/DD (ddd)")} ${dateMoment.isoWeek()}週`
}
